import * as React from 'react';
import * as R from 'ramda';
import { withRouter, RouteComponentProps } from 'react-router';
import { inject, observer } from 'mobx-react';
import { UserStore } from '../../stores';
import { computed } from 'mobx';

interface WithAuthorizationState {
    role: string | null;
}

interface WithAuthorizationProps extends RouteComponentProps<{}> {
    UserStore?: UserStore;
}

export default (allowedRoles: string[]) => (WrappedComponent: any, allowedPermissions?: string[]) => {
    @inject('UserStore') @observer
    class WithAuthorization extends React.Component<WithAuthorizationProps, WithAuthorizationState> {
        @computed get userRole() {
            return this.props.UserStore!.userInfo.userRole;
        }

        @computed get userPermissions() {
            return this.props.UserStore!.userInfo.userPermissions;
        }

        constructor(props: RouteComponentProps<{}>) {
            super(props);
        }
        render() {
            if (
                this.props.UserStore!.userRoleIn(allowedRoles) ||
                (!R.isNil(allowedPermissions) && allowedPermissions.some(x => this.props.UserStore!.checkUserPermission(x)))
            ) {
                return <WrappedComponent {...this.props} />;
            } else {
                this.props.history.push({
                    pathname: '/error',
                    state: { code: '403' }
                });

                return null;
            }
        }
    }

    return withRouter(WithAuthorization);
};


// WEBPACK FOOTER //
// ./src/components/hocs/withAuthorization.tsx